import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'
import { getUrlKey } from '@/utils/common'

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'
// axios.defaults.headers.cas_user = 'admin'
axios.defaults.baseURL = '/'
axios.defaults.timeout = 100000

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 请求前处理
    config.headers['Accept-Language'] = localStorage.getItem('lang') || 'zh-CN' // 国际化
    const token = store.state.sys.token
    if (token) {
      // 已登录情况
      try {
        config.headers['Tenant-Code'] = store.state.sys.tenantCode
        if (config.url.indexOf('/auth?') === -1) {
          // 如果不是auth接口，则需要加上token
          config.headers['Authorization'] = `Bearer ${token}`
        }
        // 判断是否需要刷新token
        // let currentTime = new Date().getTime()
        // if (
        //   currentUser.loginTime &&
        //   currentTime - currentUser.loginTime >= (currentUser.expiration / 5) * 1000 &&
        //   config.url.indexOf('/refresh') === -1
        // ) {
        //   store.dispatch('sys/refreshToken')
        // }
      } catch (e) {
        console.error(e)
        Message.error('请重新登录系统')
      }
    }
    if (store.state.sys.tenantId && store.state.sys.tenantId !== '-1' && config.url.indexOf('tenantId=') === -1) {
      let joinChar = '?'
      if (config.url.indexOf('?') !== -1) {
        joinChar = '&'
      }
      config.url = config.url + joinChar + 'tenantId=' + store.state.sys.tenantId
    }

    return config
  },
  (error) => {
    // 请求错误处理
    return Promise.reject(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  async (response) => {
    // 请求成功：2xx 范围内的状态码都会触发该函数
    const data = response.data
    return response
  },
  async (err) => {
    // 请求失败
    console.log('axios请求出错：', err, err.config, err.config.url)
    // 返回状态码不为200时候的错误处理
    const status = err.response?.status
    if (status === 401 && err.config.url !== '/service-eipauth/sso/auth') {
      await store.dispatch('sys/toLogin')
      return false
    } else {
      return Promise.reject(err.response?.data)
    }
  }
)

/**
 * @description get请求方法
 * @return Promise
 */
export function get(url, params, config = {}) {
  const urlList = url.split('?')
  if (urlList.length > 1) {
    Object.assign(params, getUrlKey(url))
  }
  return new Promise((resolve, reject) => {
    axios
      .get(urlList[0], {
        params: params,
        ...config
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        return reject(err)
      })
  })
}

/**
 * @description post请求方法
 * @return Promise
 */
export function post(url, params, config = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default axios
